import baseHttpService from "core/http/singleton/base";

import {
  getListDocFormRes,
  getListInternalDocsParams,
  getListInternalDocsRes,
  getMenuRes,
} from "./resTypes";

import {
  getInternalDocsUrl,
  getInternalDocumentMenu,
  getInternalDocumentSubMenu,
  getInternalDocumentDetailUrl,
  getDocFormUrl,
} from "./urls";

export const getInternalDocumentMenuAPI = async (
  screenCode: string
): Promise<getMenuRes> => {
  const res = await baseHttpService.get<getMenuRes>(
    getInternalDocumentMenu(screenCode)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getInternalDocumentSubMenuAPI = async (params: {
  screenCode: string;
  id: string;
}): Promise<getMenuRes> => {
  const { screenCode, id } = params;
  const res = await baseHttpService.get<getMenuRes>(
    getInternalDocumentSubMenu(screenCode),
    { fieldId: id }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getInternalDocumentDetailAPI = async (params: {
  screenCode: string;
  id: string;
}): Promise<any> => {
  const { screenCode, id } = params;
  const res = await baseHttpService.get<any>(
    getInternalDocumentDetailUrl(screenCode, id)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListInteralDocsApi = async (
  payload: getListInternalDocsParams
): Promise<getListInternalDocsRes> => {
  const { params, screenCode } = payload;
  const res = await baseHttpService.get<getListInternalDocsRes>(
    getInternalDocsUrl(screenCode),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListDocFormApi = async (
  payload: getListInternalDocsParams
): Promise<getListDocFormRes> => {
  const { params, screenCode } = payload;
  const res = await baseHttpService.get<getListDocFormRes>(
    getDocFormUrl(screenCode),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
